import React from 'react';

import { Box } from '@material-ui/core';

import { useStyles } from '../../Home/Intro/styles/introCardStyles';

export const CircleDollarCoin = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svgIcon}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 576 512'
    >
      <path
        fill='#fff'
        d='M0 416v64c0 17.7 14.3 32 32 32h160l160.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3c10.6-7.8 16.3-20 16.3-32.2c0-8.2-2.5-16.6-7.8-23.7c-13.1-17.8-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64l-16 0h-78.3c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32z'
      />
      <path
        fill='#FEE03E'
        className={classes.circleDollarCoin}
        d='M272 288A144 144 0 1 0 272 0a144 144 0 1 0 0 288zM248.1 115c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2v10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-11.4c-8.6-1.7-16.7-4.3-23.7-6.6c-1.7-.6-3.4-1.1-5-1.6c-8.4-2.6-13.1-11.6-10.5-20c2.6-8.4 11.6-13.1 20-10.5c2 .6 3.9 1.2 5.8 1.8c11.5 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3v-9.5c0-8.8 7.2-16 16-16s16 7.2 16 16v9.4c6.3 .9 12.3 2.3 17.9 3.7c8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4c-.4 .7-.9 1.6-.8 3.6z'
      />
    </svg>
  );
};
